import {
  sideNavMenuType,
  homeGridItemType,
  contactUsGridType,
  socialLinkType,
  footerListItemsType,
} from './types';

import mailIcon from '../assets/images/mail.svg';
import callIcon from '../assets/images/call.svg';
import whatsappIcon from '../assets/images/whatsapp.svg';
import onlineStoreIcon from '../assets/images/online store.svg';
import facebookIconBW from '../assets/images/facebook_bw.svg';
import instagramIconBW from '../assets/images/insta_bw.svg';
import twitterIconBW from '../assets/images/twitter_bw.svg';
import MissingSizes from '../assets/json/Find missing size.json';
import animationData from '../assets/json/Unlock_offer.json';
import mycart from '../assets/json/Cart.json';
import benefitForElite from '../assets/json/Benefit_from_Elite.json';
import selfCheckout from '../assets/json/Self_Checkout.json';
import offerData from '../assets/json/Offers.json';
import offerIcon from '../assets/images/np_discount.svg';
import signupIcon from '../assets/images/np_sign-up.svg';
import missingSizeIcon from '../assets/images/np_search.svg';
import selfCheckoutIcon from '../assets/images/np_cart.svg';
import offerWhiteIcon from '../assets/images/unlockBigIcon.svg';
import signupWhiteIcon from '../assets/images/sign up.svg';
import selfCheckoutWhiteIcon from '../assets/images/self checkout.svg';
import missingSizeWhiteIcon from '../assets/images/find a missing size.svg';

const MYcartGIF = {
  loop: true,
  autoplay: true,
  animationData: mycart,
  rendererSettings: {
    // preserveAspectRatio: "xMidYMid slice"
  },
};
const selfCheckoutGIF = {
  loop: true,
  autoplay: true,
  animationData: selfCheckout,
  rendererSettings: {
    // preserveAspectRatio: "xMidYMid slice"
  },
};
const benefitForEliteGIF = {
  loop: true,
  autoplay: true,
  animationData: benefitForElite,
  rendererSettings: {
    // preserveAspectRatio: "xMidYMid slice"
  },
};
const unlockMyOffer = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    // preserveAspectRatio: "xMidYMid slice"
  },
};
const offerAnimation = {
  loop: true,
  autoplay: true,
  animationData: offerData,
  rendererSettings: {
    // preserveAspectRatio: "xMidYMid slice"
  },
};
const missingSizes = {
  loop: true,
  autoplay: true,
  animationData: MissingSizes,
  rendererSettings: {
    // preserveAspectRatio: "xMidYMid slice"
  },
};

export const APP_ROUTES = {
  MY_INVOICES: ``,
  MY_OFFERS: `/home/offers`,
  UNLOCKED_OFFERS: `/home/unlocked-offers`,
  ELITE_BENEFITS: `/home/elite`,
  LANDMARK_REWARDS: `/home/rewards`,
  IN_STORE_PROMOTIONS: `/home/in-store-promotions`,
  UPDATE_MY_PROFILE: `/home/profile-update`,
  TAKE_A_TOUR: `/home`,
  ONLINE_STORE: ``,
  PRIVACY_POLICY: ``,
  TERMS_CONDITIONS: `/home/terms-conditions`,
  LOGOUT: `/lmrotp`,
  CONTACT_US: `/home/contact-us`,
  MISSING_SIZES: `/home/missingsizes`,
  TODAYS_ORDER: `/home/todaysorder`,
  SELECT_SIZE: `/home/selectsize`,
  SELECT_COLOR: `/home/selectcolor`,
  NOTIFY: `/home/notify`,
  LAST_PURCHASE: ``,
  CART: `/home/cart`,
  CHECKOUT: `/checkout`,
  SHOPPINGBAG: `/checkout/shoppingbag`,
  PAYMENT: `/checkout/payment`,
  CONFIRM: `/checkout/confirm`,
};

export const upperSideNavMenus: sideNavMenuType[] = [
  {
    name: 'My Orders',
    type: 'link',
    url: APP_ROUTES.TODAYS_ORDER,
  },
  {
    name: 'My Invoices',
    type: 'link',
    url: '',
    link: 'wa.link/8ht2dn',
    target: '_blank',
  },
  {
    name: 'My Offers',
    type: 'link',
    url: APP_ROUTES.UNLOCKED_OFFERS,
  },
  {
    name: 'Benefit from ELITE',
    type: 'link',
    url: APP_ROUTES.ELITE_BENEFITS,
  },
  {
    name: 'Landmark Rewards',
    type: 'link',
    url: APP_ROUTES.LANDMARK_REWARDS,
  },
  {
    name: 'In-Store Promotions',
    type: 'link',
    url: APP_ROUTES.IN_STORE_PROMOTIONS,
  },
  {
    name: 'Update my Profile',
    type: 'link',
    url: APP_ROUTES.UPDATE_MY_PROFILE,
  },
];

export const lowerSideNavMenus: sideNavMenuType[] = [
  {
    name: 'Take a Tour',
    type: 'text',
    url: APP_ROUTES.TAKE_A_TOUR,
  },
  {
    name: 'Contact Us',
    type: 'link',
    url: APP_ROUTES.CONTACT_US,
  },
  {
    name: 'Terms and Conditions',
    type: 'link',
    url: APP_ROUTES.TERMS_CONDITIONS,
  },
  {
    name: 'Logout',
    type: 'text',
    url: APP_ROUTES.LOGOUT,
  },
];

export const homeGridItems: homeGridItemType[] = [
  {
    icon: offerWhiteIcon,
    text1: 'Unlock my',
    text2: 'Offers',
    url: APP_ROUTES.MY_OFFERS,
  },
  {
    icon: missingSizeWhiteIcon,
    text1: 'Find a',
    text2: 'missing size',
    url: APP_ROUTES.MISSING_SIZES,
  },
  // To be uncommented in Phase 2
  {
    icon: selfCheckoutWhiteIcon,
    text1: 'Self',
    text2: 'Checkout',
    url: APP_ROUTES.CHECKOUT,
  },
  {
    icon: signupWhiteIcon,
    text1: 'Benefit',
    text2: 'from ELITE',
    url: APP_ROUTES.ELITE_BENEFITS,
  },
];

//To Be Removed In Phase 2
// export const upcomingHomeItems: homeGridItemType[] = [
//   {
//     icon: selfCheckoutWhiteIcon,
//     text1: 'Self',
//     text2: 'Checkout',
//     url: '',
//   },
//   {
//     icon: signupWhiteIcon,
//     text1: 'Benefit',
//     text2: 'from ELITE',
//     url: '',
//   },
// ];

export const contactUsGridItems: contactUsGridType[] = [
  {
    icon: mailIcon,
    text1: 'Mail',
    text2: null,
    link: 'mailto:help.in@maxfashion.com',
    target: null,
  },
  {
    icon: callIcon,
    text1: 'Call',
    text2: '10AM - 10PM',
    link: 'tel:18001231444',
    target: null,
  },
  {
    icon: whatsappIcon,
    text1: 'WhatsApp',
    text2: null,
    link: '',
    target: null,
  },
  {
    icon: onlineStoreIcon,
    text1: 'Online Store',
    text2: null,
    link: 'https://www.maxfashion.in',
    target: '_blank',
  },
];

export const socialLinksContacUs: socialLinkType[] = [
  {
    link: 'https://facebook.com/maxfashions',
    type: 'Facebook',
    text: 'Facebook.com/maxfashions',
    icon: facebookIconBW,
  },
  {
    link: 'https://twitter.com/maxfashionindia',
    type: 'Twitter',
    text: 'Twitter.com/maxfashionindia',
    icon: twitterIconBW,
  },
  {
    link: 'https://instagram.com/maxfashionindia',
    type: 'Instagram',
    text: 'Instagram.com/maxfashionindia',
    icon: instagramIconBW,
  },
];
export const tourGuideGif = [
  unlockMyOffer,
  unlockMyOffer,
  missingSizes,
  offerAnimation,
  MYcartGIF,
  selfCheckoutGIF,
  benefitForEliteGIF,
];

export const EliteAlphaNumStoreCode = [];
export const EliteNumericStoreCode = [];
export const EliteEnableStatus = true;
export const EliteItemCode = '1000012573848';
//'2193', '4955', 'LnMaChnMcvQrc0091','LnMaBlrBskQrc0001',
export const footerItems: footerListItemsType[] = [
  {
    icon: offerIcon,
    activeIcon: offerWhiteIcon,
    url: [APP_ROUTES.MY_OFFERS, APP_ROUTES.UNLOCKED_OFFERS],
  },
  {
    icon: missingSizeIcon,
    activeIcon: missingSizeWhiteIcon,
    url: [
      APP_ROUTES.MISSING_SIZES,
      APP_ROUTES.SELECT_SIZE,
      APP_ROUTES.SELECT_COLOR,
      APP_ROUTES.NOTIFY,
    ],
  },
  {
    icon: selfCheckoutIcon,
    activeIcon: selfCheckoutWhiteIcon,
    url: [
      APP_ROUTES.CHECKOUT,
      APP_ROUTES.SHOPPINGBAG,
      APP_ROUTES.PAYMENT,
      APP_ROUTES.CONFIRM,
    ],
  },
  {
    icon: signupIcon,
    activeIcon: signupWhiteIcon,
    url: APP_ROUTES.ELITE_BENEFITS,
  },
];

export const WHATS_APP_URL = `whatsapp://send?phone=919008411111&text=I would like to signup to receive updates from Max Fashion&lang=en`;
export const eventNames = {
  checkSizeBarcode: 'checkSizeAvailabilityEvent',
  searchByBarcode: 'searchByBarcodeEvent',
  barcodeScanned: 'barcodeScannedEvent',
  whatsappSignUp: 'whatsappsignupEvent',
  selfCheckout: 'selfCheckoutEvent',
  bannerEventName: 'BannerDetailEvent',
  inStoreEvent: 'promotionClickedEvent',
  offerEvent: 'WalletOfferClickedEvent',
  addTObagEvent: 'checkoutaddtobagevent',
  couponAppliedPaymentEvent: 'couponAppliedPaymentStatusEvent',
  onPaynowEvent: 'payNowPaymentStatusEvent',
  paymentRecieveEvent: 'onPaymentRecieveEvent',
  eventBillingEvent: 'eventBillingEvent',
  orderPaymentDoneEvent: 'orderPaymentDoneEvent',
  loginEvent: 'loginEvent',
  loginEventGA: 'loginEventGA',
};
export const whatsAppStatusMesages = {
  optin: 'enroll',
  notOpted: 'not-enroll',
};
export const scanCodeEvent = 'scanCodeEvent';
export const orderCompleteEvent = 'orderCompleteEvent';
export const qrCodeEvent = 'qrCodeScannedEvent';
export const bannerEvent = 'bannerClickedEvent';
export const pageName = {
  homePage: 'lmr-home-page',
  loginPage: 'lmr-login-page',
  rewardPage: 'lmr-reward-page',
  missingsize: 'lmr-missingsize-page',
  customerEnrollment: 'lmr-enrollment-page',
  paymentConfirm: 'payment-confirm-page',
  shoppingPage: 'lmr-cart-page',
  promotionPage: 'in-store-promotion-page',
  splashScreen: 'lmr-splash-screen',
  qrCodePage: 'lmr-landing-page',
  updateProfilePage: 'customer-profile-update-page',
  termsConditionPage: 'lmr-terms&Conditions-page',
  contactusPage: 'lmr-contact-us-Page',
  offerDetailPage: 'Offer-Details-Page',
  scanOfferQrPage: 'Scan-My-Offer-Qr-Page',
  checkoutPage: 'checkout-scan-page',
  paymentPage: 'checkout-payment-page',
  thankyoupage: 'customer-thankyou-page',
  employeesigninPage: 'employee-signin-page',
  temppasswordpage: 'emp-temporary-password-page',
  resetpassword: 'employee-reset=password-page',
  storeIdentificationPage: 'emp-confirm-location-page',
  empLocationError: 'emp-locationerror-page',
  elitePage: 'benefit-elite-page',
};

export const WebsiteUrl = 'https://www.maxfashion.in/in/';

export const PAYTM_MID_META_KEY = 'paytm-checkout-url';

export const qrPaymentMode = 'qrcodepayment';
export const linkPaymentMode = 'linkPayment';
